// extracted by mini-css-extract-plugin
export default {"tooltipContent":"N7BIqI","tooltipBase":"DMu5gt"};